import {
  useQuery,
  // useMutation,
} from 'react-query';
import { globalStore } from 'rekv';
import UserStore from '../../stores/account';
import { tokenApi, nftsApi, streamApi } from '../contracts';
import { getNFTAddr } from '../../utils/web3';
import {
  formatBalance,
  getMetadata,
  getConfig,
  postQuery,
  postQueryRice,
  postQueryNFTs,
  postQueryVesting,
  timeformater,
} from '../../utils';

export * from './queryClient';

const OVO_QUERY = 'getOVOInfo';
const QUERY_USER_NFTS = 'getUserNFTs';
const STREAM_QUERY = 'getStreamInfo';
const CONFIG_QUERY = 'getConfig';
const QUERY_USER_NFT = 'getUserNFT';
const QUERY_USER_NFT_BY_IDS = 'getUserNFTByIDs';
const QUERY_USER_MAINNET_RICE = 'getUserMainnetRice';

export const getConnectedState = () => {
  const { appState = {} } = globalStore.useState('appState');
  const { connected = false } = appState;
  return connected;
};

export const getAddrState = () => {
  const { appState = {} } = globalStore.useState('appState');
  const { address = false } = appState;
  return address;
};

export const useUserVestingInfo = (addr: string) => {
  const stream = streamApi();
  const vestingMap: any = {};
  const vestingTokenMap: any = {};
  const tokenNumsMap: any = {};

  const getVestingNumByNFTId = async (streamId: string, tokenId: number) => {
    const claimable = await stream.getClaimable(streamId, tokenId);
    const remain = await stream.getRemain(streamId, tokenId);
    const query = `
    {
      claimedByTokenIdEntities(where:{tokenId:${tokenId}}){
        amount
        tokenId
      }
    }`;
    const { claimedByTokenIdEntities = [] } = await postQueryVesting(query.toString(), {});
    // console.log(streamId, tokenId, '------');
    let claimedNum = 0;
    claimedByTokenIdEntities.map((e: any) => {
      const claimedAmount = formatBalance(e.amount) || 0;
      claimedNum += Number(claimedAmount);
      return null;
    });
    const nums = {
      tokenId,
      streamId,
      claimable: Number(formatBalance(claimable)),
      remain: Number(formatBalance(remain)),
      claimed: claimedNum,
    };
    tokenNumsMap[tokenId] = nums;

    const streamInfo = vestingMap[streamId];
    if (streamInfo) {
      streamInfo.locked += nums.remain - nums.claimable;
      streamInfo.claimable += nums.claimable;
      streamInfo.claimed += nums.claimed;
    }
    vestingMap[streamId] = streamInfo;
  };

  const getInfos = async () => {
    if (!addr) {
      return [];
    }
    const address = addr.toLowerCase();
    const query = `{
      owners(where: {id:"${address}"}) {
        ownedTokens {
          id
        }
        balance
      }
    }`;
    const { owners = [] } = await postQueryNFTs(query.toString(), {});
    let nfts: any = [];
    let balance = 0;
    if (owners[0]) {
      balance = owners[0].balance;
      nfts = owners[0].ownedTokens.map((token: any) => {
        return Number(token.id);
      });
    }

    const vestingQuery = `
    {
      allocationsEntities {
        id
        streamId
        startIndex
        allocateSize
      }
    }
    `;

    const { allocationsEntities = [] } = await postQueryVesting(vestingQuery.toString(), {});
    const { streamEntities = [] } = await await postQueryVesting(
      `{
      streamEntities{
        id
        streamId
        tokenAddress
        startTime
        stopTime
      }
    }`,
      {},
    );

    streamEntities.map((s: any) => {
      vestingMap[s.streamId] = s;
      return null;
    });

    const reqArr = [];
    let i = 0;
    while (i < allocationsEntities.length) {
      const item = allocationsEntities[i];
      const { startIndex, allocateSize, streamId } = item;

      let j = 0;
      while (j < nfts.length) {
        const n = nfts[j];
        if (n >= Number(startIndex) && n < Number(startIndex) + Number(allocateSize)) {
          const streamInfo = vestingMap[streamId];
          const data = { ...streamInfo, ...item, claimable: 0, claimed: 0, locked: 0 };
          vestingMap[streamId] = data;
          const tokenArr = vestingTokenMap[streamId] || [];
          tokenArr.push(n);
          vestingTokenMap[streamId] = tokenArr;
          reqArr.push(getVestingNumByNFTId(streamId, n));
        }
        j += 1;
      }
      i += 1;
    }

    await Promise.all(reqArr);

    UserStore.setState({ nfts, vestingMap, vestingTokenMap, tokenNumsMap });

    const userVestings = [];
    Object.keys(vestingTokenMap).map((key) => {
      userVestings.push(vestingMap[key]);
      return null;
    });

    return userVestings;
  };

  return useQuery(`${QUERY_USER_NFTS}${addr}`, getInfos);
};

const getStreamInfo = async (idx: any) => {
  // todo add cards
  // get ovo Wxdai bal
  const stream = streamApi();
  const streamInfo = await stream.getStreamInfo(idx);
  // console.log(streamInfo);
  return { ...streamInfo, streamId: idx };
};
// query streaming info
export const useStreamInfo = (idx: number, address: string) => {
  // const connect = getConnectedState();
  // if (!connect) return { data: {} };

  return useQuery(`${STREAM_QUERY}${idx}`, () => getStreamInfo(idx));
};

// export const queryCardByConfig = (cards: any) => {
//   const pool = {};
//   const nfts = nftsApi();
//   const getCardInfo = async (poolId: number, cardId: number) => {
//     const cardConfig = await pool.getCard(poolId, cardId);
//     // console.log(cardId, '==', cardConfig);
//     const metadata = await getMetadata(cardId.toString());
//     const maxSupply = await nfts.getCardLimt(cardId);
//     const totalSupply = await nfts.getCardTotalSupply(cardId);
//     const userPoints = await pool.earned(poolId);
//     const redeemCount = await pool.getRedeemCount(poolId, cardId);

//     return {
//       ...cardConfig,
//       ...metadata,
//       maxSupply,
//       totalSupply,
//       poolId,
//       cardId,
//       userPoints,
//       redeemCount,
//     };
//   };

//   const getCards = async () => {
//     const reqs = cards.map((card: any) => {
//       const { poolId, cardId } = card;
//       return getCardInfo(poolId, cardId);
//     });
//     const res = await Promise.all(reqs);
//     return { cards: res };
//   };

//   return useQuery(`${CARDS_QUERY_BY_INFO}`, getCards);
// };

// export const queryCardByIds = (cards: any) => {
//   const nfts = nftsApi();
//   const getCardInfo = async (card: any) => {
//     const { cardId } = card;
//     const metadata = await getMetadata(cardId.toString());
//     const maxSupply = await nfts.getCardLimt(cardId);
//     const totalSupply = await nfts.getCardTotalSupply(cardId);

//     return {
//       ...metadata,
//       maxSupply,
//       totalSupply,
//       ...card,
//     };
//   };

//   const getCards = async () => {
//     const reqs = cards.map((card: any) => {
//       return getCardInfo(card);
//     });
//     const res = await Promise.all(reqs);
//     return { cards: res };
//   };

//   return useQuery(`${CARDS_QUERY_BY_IDS}`, getCards);
// };

export const useConfig = () => {
  const getConfigData = async () => {
    const poolConfig = await getConfig('poolConfig');
    const redeemConfig = await getConfig('redeemConfig');
    const disableCards = await getConfig('disableCards');
    return { poolConfig, redeemConfig, disableCards };
  };
  return useQuery(`${CONFIG_QUERY}`, getConfigData);
};

export const useUserNFT = (addr: string) => {
  const nfts = nftsApi();

  const getCardInfo = async (card: any) => {
    const { cardId } = card;
    const metadata = await getMetadata(cardId.toString());
    const maxSupply = await nfts.getCardLimt(cardId);
    const totalSupply = await nfts.getCardTotalSupply(cardId);
    if (cardId >= 0 && cardId <= 200) {
      metadata.image =
        'https://dsincubator.oss-ap-southeast-1.aliyuncs.com/test/DKP-RICE-Vesting.gif';
    }
    return {
      ...metadata,
      maxSupply,
      totalSupply,
      ...card,
    };
  };
  const getUserNFT = async () => {
    if (!addr) {
      return {};
    }
    const query = `{
      cardOwners(where:{owner:"${addr.toLowerCase()}"}){
        amount
        cardId
      }
    }`;
    const { cardOwners = [] } = await postQuery(query.toString(), {});

    return cardOwners;
  };

  const getOwnedCards = async () => {
    const cards = await getUserNFT();
    const reqs = cards.map((card: any) => {
      return getCardInfo(card);
    });
    const res = await Promise.all(reqs);
    return { cards: res };
  };

  return useQuery(`${QUERY_USER_NFT}`, getOwnedCards);
};

export const useUserRiceMainnet = (addr: string) => {
  const getUserMainnetRice = async () => {
    if (!addr) {
      return [];
    }
    const query = `{
  accounts(where:{id: "${addr.toLowerCase()}"}) {
    balances {
      value
    }
  }
}`;
    const { accounts = [] } = await postQueryRice(query.toString(), {});
    return accounts;
  };

  return useQuery(`${QUERY_USER_MAINNET_RICE}`, getUserMainnetRice);
};

export const useNFTsByIDs = (nfts = []) => {
  const getNFTData = async () => {
    const nftReq: any = [];
    nfts.map((nft: number) => {
      nftReq.push(getMetadata(nft.toString()));
      return null;
    });
    const nftDatas = await Promise.all(nftReq);
    return nftDatas;
  };
  return useQuery(`${QUERY_USER_NFT_BY_IDS}`, getNFTData);
};

export const useUserOwnedVestingInfo = (addr: string) => {
  const getDatas = async () => {
    if (!addr) {
      return [];
    }
    const query = `{
    streamEntities(where: {sender: "${addr}"}) {
      id
      streamId
      startTime
      stopTime
      sender
      tokenAddress
      erc721Address
    }
}`;
    const { streamEntities = [] } = await postQueryVesting(query.toString(), {});

    const streamReqArr: any = [];
    const streamMap = {};
    streamEntities.map((e: any) => {
      streamReqArr.push(getStreamInfo(e.streamId));
      streamMap[e.streamId] = e;
      return null;
    });

    const resArr = await Promise.all(streamReqArr);

    resArr.map((res) => {
      const entity = streamMap[res.streamId];
      res.balance = formatBalance(res.remainingBalance);

      res.claimed =
        Number(formatBalance(res.deposit)) - Number(formatBalance(res.remainingBalance));
      res.deposit = formatBalance(res.deposit);

      res.startTime = timeformater(res.startTime);
      res.stopTime = timeformater(res.stopTime);

      streamMap[res.streamId] = { ...entity, ...res };

      return null;
    });

    console.log(streamMap, '.....----');
    return Object.values(streamMap);
  };

  return useQuery(`${QUERY_USER_MAINNET_RICE}`, getDatas);
};
